import React from "react";
import { itinerary } from "../mock";
import useReveal from "../hooks/useReveal";

function Timeline({ events }) {
  return (
    <div className="space-y-10">
      {events.map((ev, i) => (
        <div key={i} className="flex gap-6">
          <div className="font-serif-display text-2xl text-[#9E2B25] w-16 shrink-0">{ev.time}</div>
          <div className="border-l border-[#211E1A]/15 pl-6">
            <h4 className="font-serif-display text-[26px] text-[#211E1A] leading-tight">{ev.name}</h4>
            <p className="mt-2 text-[#4a443d] leading-relaxed max-w-md">{ev.text}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

function Day({ day, reverse }) {
  const [ref, visible] = useReveal();
  return (
    <div
      ref={ref}
      className={`grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center reveal ${
        visible ? "is-visible" : ""
      }`}
    >
      <div className={`img-zoom h-[440px] md:h-[560px] overflow-hidden border-[6px] border-[#F4EFE6] shadow-xl ${reverse ? "md:order-2" : ""}`}>
        <img src={day.image} alt={day.title} className="w-full h-full object-cover" />
      </div>
      <div className={reverse ? "md:order-1" : ""}>
        <p className="text-[12px] uppercase tracking-widest-2 text-[#6b6157]">{day.dateLabel}</p>
        <h3 className="mt-2 mb-10 font-serif-display text-[40px] md:text-[52px] text-[#211E1A]">{day.title}</h3>
        <Timeline events={day.events} />
      </div>
    </div>
  );
}

export default function Itinerary() {
  return (
    <section id="schedule" className="py-24 md:py-36 px-6">
      <div className="max-w-[1150px] mx-auto">
        <h2 className="text-center font-serif-display text-[#9E2B25] text-[46px] md:text-[68px] mb-20">
          {itinerary.title}
        </h2>
        <div className="space-y-28">
          <Day day={itinerary.dayOne} reverse={false} />
          <Day day={itinerary.dayTwo} reverse={true} />
        </div>
      </div>
    </section>
  );
}
